import UserInterfaceCheck from '@mds/icons/Check';
import { Box, Paper, Typography } from '@mui/material';
import { MessageView } from 'components/ui/Feedback';

import React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { getChannelLink } from '../../../utils/link.utils';
import { EmailNeonSales } from '../../ui/EmailNeonSales';
import { isValidMongoId } from '../../../utils/id-validation.utils';

const PremiumChannelSubscribeNoClearingAccountConfirm = () => {
    const history = useHistory();
    const { channelId } = useParams<{ channelId: string }>();
    const isValidChannelId = isValidMongoId(channelId);

    if (!isValidChannelId) {
        return (
            <MessageView
                styleName="primary"
                size="large"
                title="Channel not found"
                primaryAction={{
                    label: 'Return to Neon Insights',
                    onClick: () => history.push('/'),
                }}
            />
        );
    }

    return (
        <Box
            sx={{
                display: 'flex',
                height: 'calc(100vh - 212px)',
                alignItems: 'center',
                pt: { xs: 4, sm: 0 },
            }}
        >
            <MessageView
                styleName="primary"
                title={'Request your free trial'}
                primaryAction={{
                    label: 'Back to channel',
                    onClick: () => history.push(getChannelLink(channelId)),
                    styleName: 'primary',
                }}
            >
                <Box
                    sx={{
                        mt: 2,
                        pb: 4,
                        '& p:not(:last-child)': { mb: 4 },
                    }}
                >
                    <Typography
                        variant="body1"
                        sx={{
                            color: 'text.secondary',
                        }}
                    >
                        Currently, in-app channel subscriptions are only
                        available to Marex Clearing clients.
                    </Typography>
                    <Typography
                        variant="body1"
                        sx={{
                            color: 'text.secondary',
                        }}
                    >
                        You can register your interest for a free trial to this
                        Channel and we will contact you to discuss pricing and
                        alternative payment options.
                    </Typography>
                </Box>
                <Paper sx={{ p: 2 }}>
                    <Box
                        sx={{
                            display: 'flex',
                        }}
                    >
                        <UserInterfaceCheck
                            fontSize="small"
                            sx={{ width: 12, height: 12, pt: '5px', pl: '5px' }}
                        />
                        <Typography
                            variant="caption"
                            sx={{ fontWeight: 'fontWeightBold' }}
                        >
                            Thank you for registering your interest. A member of
                            the Neon team will be in touch soon. If you need
                            further assistance, you can email us at &nbsp;
                            <EmailNeonSales />
                        </Typography>
                    </Box>
                </Paper>
            </MessageView>
        </Box>
    );
};

export default PremiumChannelSubscribeNoClearingAccountConfirm;
